import { useState, useEffect, useCallback } from 'react';
import { idbService, offlineModeService } from 'utils/services';

const useIsReadyAndOffline = () => {
  const [isReadyAndOffline, setIsReadyAndOffline] = useState(false);

  const compute = useCallback(async () => {
    try {
      const offlineMode = await offlineModeService.get();
      if (!offlineMode) {
        setIsReadyAndOffline(false);
        return;
      }
      const db = await idbService.initiateIDB();
      const readyData = await db.transaction('ready').objectStore('ready').get('ready');
      setIsReadyAndOffline(!!readyData?.isReady);
    } catch (e) {
      setIsReadyAndOffline(false);
    }
  }, []);

  useEffect(() => {
    compute();
    const unsubscribe = offlineModeService.subscribe(() => {
      compute();
    });
    return unsubscribe;
  }, [compute]);

  return isReadyAndOffline;
};

export default useIsReadyAndOffline;
